import React from 'react'

function CareersPage() {
  return (
    <div>CareersPage</div>
  )
}

export default CareersPage